module.exports = __webpack_public_path__ + "static/media/above-fold.4fb463bc.svg";